(function ($) {
  DJ.addBehavior('doughnutChart', '.doughnut-chart__chart-holder', {
    attach: function () {
      const chartContainer = this;
      const chartCanvas = chartContainer.querySelector('.doughnut-chart__canvas').getContext('2d');
      const toolTipsContainer = chartContainer.querySelector('.doughnut-chart__legend');
      const customToolTips = chartContainer.querySelectorAll('.doughnut-chart-legend-item');
      const dataForChart = [];
      const chartColors = [
        '#68699A',
        '#C8C9D9',
        '#F9E6C9',
        '#F9C26A',
        '#D38507',
        '#003887',
        '#070859'
      ];

      if (customToolTips) {
        const customToolTipsArr = Array.prototype.slice.call(customToolTips);

        customToolTipsArr.forEach((item) => {
          if (item.getAttribute('data-number')) {
            dataForChart.push(parseInt(item.getAttribute('data-number'), 10));
          }
        });
      }

      const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';

        for (let i = 0; i < 6; i += 1) {
          color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
      };

      const generateChartColors = () => {
        if (!customToolTips && !chartColors) {
          return [];
        }

        const neededColorsAmount = customToolTips.length - chartColors.length;

        for (let i = 0; i < neededColorsAmount; i += 1) {
          chartColors.push(getRandomColor());
        }

        return chartColors;
      };

      Chart.defaults.RoundedDoughnut = Chart.helpers.clone(Chart.defaults.doughnut);
      Chart.controllers.RoundedDoughnut = Chart.controllers.doughnut.extend({
        draw: function (ease) {
          const { ctx } = this.chart;
          const easingDecimal = ease || 1;
          const arcs = this.getMeta().data;
          Chart.helpers.each(arcs, function (arc, i) {
            arc.transition(easingDecimal).draw();

            const pArc = arcs[i === 0 ? arcs.length - 1 : i - 1];
            // eslint-disable-next-line no-underscore-dangle
            const pColor = pArc._view.backgroundColor;

            // eslint-disable-next-line no-underscore-dangle
            const vm = arc._view;
            const radius = (vm.outerRadius + vm.innerRadius) / 2;
            const thickness = (vm.outerRadius - vm.innerRadius) / 2;
            const startAngle = Math.PI - vm.startAngle - Math.PI / 2;
            const angle = Math.PI - vm.endAngle - Math.PI / 2;

            ctx.save();
            ctx.translate(vm.x, vm.y);

            ctx.fillStyle = i === 0 ? vm.backgroundColor : pColor;
            ctx.beginPath();
            // eslint-disable-next-line max-len
            ctx.arc(radius * Math.sin(startAngle), radius * Math.cos(startAngle), thickness, 0, 2 * Math.PI);
            ctx.fill();

            ctx.fillStyle = vm.backgroundColor;
            ctx.beginPath();
            ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI);
            ctx.fill();

            ctx.restore();
          });
        }
      });

      if (dataForChart.length && chartCanvas) {
        const doughnutChart = new Chart(chartCanvas, {
          type: 'RoundedDoughnut',
          plugins: [{
            beforeRender: function (chart) {
              const thisChart = chart;
              if (thisChart.config.options.showAllTooltips) {
                // create an array of tooltips
                // we can't use the chart tooltip because there is only one tooltip per chart
                thisChart.pluginTooltips = [];
                thisChart.config.data.datasets.forEach(function (dataset, i) {
                  thisChart.getDatasetMeta(i).data.forEach(function (sector, j) {
                    thisChart.pluginTooltips.push(new Chart.Tooltip({
                      _chart: thisChart.chart,
                      _chartInstance: thisChart,
                      _data: thisChart.data,
                      _options: thisChart.options.tooltips,
                      _active: [sector]
                    }, thisChart));
                  });
                });

                // turn off normal tooltips
                thisChart.options.tooltips.enabled = false;
              }
            },
            afterDraw: function (chart, easing) {
              const thisChart = chart;
              if (thisChart.config.options.showAllTooltips) {
                // we don't want the permanent tooltips to animate,
                // so don't do anything till the animation runs atleast once
                if (!thisChart.allTooltipsOnce) {
                  if (easing !== 1) { return; }
                  thisChart.allTooltipsOnce = true;
                }

                // turn on tooltips
                thisChart.options.tooltips.enabled = true;
                Chart.helpers.each(thisChart.pluginTooltips, function (tooltip, i) {
                  tooltip.initialize();
                  tooltip.update();
                });

                const pluginTooltipsArr = Array.prototype.slice.call(thisChart.pluginTooltips);

                pluginTooltipsArr.forEach((tooltip, i) => {
                  if (customToolTips[i] && !customToolTips[i].classList.contains('doughnut-chart-legend-item--placed')) {
                    // eslint-disable-next-line no-underscore-dangle
                    const tooltipTop = tooltip._model.caretY;
                    // eslint-disable-next-line no-underscore-dangle
                    const tooltipLeft = tooltip._model.caretX;

                    customToolTips[i].style.width = `${customToolTips[i].offsetWidth + 39}px`;
                    customToolTips[i].classList.add('doughnut-chart-legend-item--placed');
                    customToolTips[i].style.top = `${tooltipTop}px`;

                    // eslint-disable-next-line no-underscore-dangle
                    if (tooltip._model.caretX <= (chartContainer.offsetWidth / 2)) {
                      customToolTips[i].classList.add('doughnut-chart-legend-item--align-left');
                      // eslint-disable-next-line no-underscore-dangle
                      customToolTips[i].style.left = `${tooltip._model.x - customToolTips[i].offsetWidth}px`;
                    } else {
                      // eslint-disable-next-line no-underscore-dangle
                      customToolTips[i].style.left = `${tooltipLeft}px`;
                    }

                    // eslint-disable-next-line no-underscore-dangle
                    if (tooltip._model.labelColors[0]
                      // eslint-disable-next-line no-underscore-dangle
                      && tooltip._model.labelColors[0].backgroundColor) {
                      const toolTipColor = customToolTips[i].querySelector('.doughnut-chart-legend-item__color');

                      if (toolTipColor) {
                        // eslint-disable-next-line no-underscore-dangle
                        toolTipColor.style
                          // eslint-disable-next-line no-underscore-dangle
                          .backgroundColor = tooltip._model.labelColors[0].backgroundColor;
                      }
                    }
                  }
                });

                const customToolTipsArr = Array.prototype.slice.call(customToolTips);

                customToolTipsArr.forEach((item, i) => {
                  const currentItem = item;
                  const nextItem = customToolTipsArr[i + 1];

                  if (nextItem) {
                    if (currentItem.classList.contains('doughnut-chart-legend-item--align-left')
                      && nextItem.classList.contains('doughnut-chart-legend-item--align-left')) {
                      if ((nextItem.offsetTop + nextItem.offsetHeight) >= currentItem.offsetTop) {
                        chartContainer.classList.add('doughnut-chart__chart-holder--mobile-view');

                        return false;
                      }
                    } else if
                    (!nextItem.classList.contains('doughnut-chart-legend-item--align-left')
                      && (currentItem.offsetTop + currentItem.offsetHeight)
                      >= nextItem.offsetTop) {
                      chartContainer.classList.add('doughnut-chart__chart-holder--mobile-view');

                      return false;
                    }
                  }

                  return true;
                });

                if (!toolTipsContainer.classList.contains('doughnut-chart__legend--visible')) {
                  toolTipsContainer.classList.add('doughnut-chart__legend--visible');
                }

                if (!chartContainer.classList.contains('doughnut-chart__chart-holder--chart-complete')) {
                  chartContainer.classList.add('doughnut-chart__chart-holder--chart-complete');
                }

                thisChart.options.tooltips.enabled = false;
              }
            }
          }],
          data: {
            datasets: [
              {
                data: dataForChart,
                backgroundColor: generateChartColors(),
                borderWidth: 0
              }]
          },
          options: {
            cutoutPercentage: 85,
            maintainAspectRatio: false,
            showAllTooltips: true,
            legend: {
              display: false
            }
          }
        });
      }
    }
  });
})(jQuery);
